import { Component, EventEmitter, Injector, Input, OnInit, Output,  } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { InformationSourceState } from '@proxy/information-sources';
import { EnumDescriptor } from '../../enum-descriptor';

@Component({
    selector: 'app-information-source-state-dropdown',
    templateUrl: './information-source-state-dropdown.component.html',
    standalone: false
})
export class InformationSourceStateDropdownComponent
  extends AppBaseComponent
  implements OnInit {

  @Input() isRequired: boolean;
  @Input() informationSourceState: InformationSourceState;

  @Output() changeInformationSourceState = new EventEmitter<InformationSourceState>();

  informationSourceStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.informationSourceState)) {
      this.informationSourceState = InformationSourceState.Active;
    }
    
    this.loadInformationSourceState();
    this.onSelected();
  }

  loadInformationSourceState(): void {
    this.informationSourceStates = this.getEnumOptions(InformationSourceState, false);
  }

  onSelected(): void {
    this.changeInformationSourceState.emit(this.informationSourceState);
  }
}
